import axios from 'axios';
import jwtHelper from '../components/common/jwt/jwtHelper';
import Notifier from '../components/message/Notifier';
import { ERRORS } from './constants';

axios.interceptors.request.use(jwtHelper.getRequestInterceptor());

axios.interceptors.response.use(
    response => response,
    jwtHelper.getErrorResponseInterceptor()
);

axios.interceptors.response.use(
    response => response,
    (error) => {
        const status = error.response?.status;
        const originalRequest = error.config;
        if (status === 401 && originalRequest?._retry) {
            console.log('[Axios Error Handler] 401 after retry - rejecting');
        } else if (error.response?.data?.messages) {
            error.response.data.messages.forEach(msg => Notifier[msg.severity](msg.text));
        } else if (error.message === ERRORS.network_error.error) {
            Notifier.error(ERRORS.network_error.message, ERRORS.network_error.title, true);
        }

        return Promise.reject(error);
    }
);
